'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEventName = exports.eventNames = exports.props = exports.EVENT_WEBAPI_REQUEST_FETCH = exports.EVENT_WEBAPI_REQUEST_DESKPRO = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('../Core/Event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_WEBAPI_REQUEST_DESKPRO = exports.EVENT_WEBAPI_REQUEST_DESKPRO = 'webapi.request.deskpro'; /**
                                                                                                     * WebAPI module.
                                                                                                     * @module WebAPI/events
                                                                                                     */

var EVENT_WEBAPI_REQUEST_FETCH = exports.EVENT_WEBAPI_REQUEST_FETCH = 'webapi.request.fetch';

var events = {
  EVENT_WEBAPI_REQUEST_DESKPRO: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_WEBAPI_REQUEST_FETCH: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};
/**
 * @enum
 * @readonly
 *
 * @type {{EVENT_WEBAPI_REQUEST_DESKPRO: {channelType, invocationType}, EVENT_WEBAPI_REQUEST_FETCH: {channelType, invocationType}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 * @param {String} name
 * @return {boolean}
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/WebAPI/events.js
// module id = 159
// module chunks = 0